import React from 'react';
import {
  Box,
  Card,
  Column,
  Row,
  SkeletonLoader,
} from '@chargify/custom-ui-components';

import DetailsSectionLoadingSkeleton from '../DetailsSectionLoadingSkeleton';
import { SectionDivider } from './CustomerDetailsLoader.styles';

const CustomerDetailsLoader = () => (
  <Card>
    <Box padding={7}>
      <Row>
        <Column span={[24, 7]}>
          <SkeletonLoader width={150} height={30} />
        </Column>
        <Column span={[24, 17]}>
          <DetailsSectionLoadingSkeleton />
        </Column>
      </Row>
      <SectionDivider marginBottom={7} paddingTop={7} />
      <Row>
        <Column span={[24, 7]}>
          <SkeletonLoader width={180} height={30} />
        </Column>
        <Column span={[24, 17]}>
          <DetailsSectionLoadingSkeleton />
        </Column>
      </Row>
    </Box>
  </Card>
);

export default CustomerDetailsLoader;
